/// <amd-module name="Checks/Approvals/Web/Components/AccordionComponent" />
import React = require("react");

import { Accordion, IAccordionProps, IAccordionSection } from "VSSUI/Accordion";
import { IVssComponentProperties, VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { ObservableValue, ObservableArray } from "VSS/Core/Observable";

export interface IAccordionComponentProps extends IVssComponentProperties {
    uniqueKey: string;
    title: string;
    className?: string;
}

export class AccordionComponent extends VssComponent<IAccordionComponentProps, {}> {

    constructor(props: IAccordionComponentProps) {
        super(props);
        this._accordionItems = [
            {
                key: this.props.uniqueKey,
                title: this.props.title,
                isCollapsed: this._accordionCollapsedState,
                onRenderContent: () => {
                    return (
                        <div>
                        { this.props.children }
                        </div>
                    );
                }
            }
        ];
    }

    public render(): JSX.Element {
        return (
            <Accordion
                className={this.props.className}
                sections={this._accordionItems}
                onSectionClicked={this._onCollapsibleSectionGroupClicked} />
        );
    }

    private _onCollapsibleSectionGroupClicked = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, section: IAccordionSection): void => {
        this._accordionCollapsedState.value = !this._accordionCollapsedState.value;
    }

    private _accordionItems: IAccordionSection[];
    private _accordionCollapsedState: ObservableValue<boolean> = new ObservableValue<boolean>(true);

}
